/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PersonResumeeCourseregistrationidAverageGrade200,
  PostApiV1PersonResumeeCourseregistrationidAverageGrade400,
  PostApiV1PersonResumeeCourseregistrationidAverageGrade401,
  PostApiV1PersonResumeeCourseregistrationidAverageGrade500,
  PostApiV1PersonResumeeCourseregistrationidAverageGradeMutationResponse,
  PostApiV1PersonResumeeCourseregistrationidAverageGradePathParams,
} from "../../types/personResumeeController/PostApiV1PersonResumeeCourseregistrationidAverageGrade.ts";

export const postApiV1PersonResumeeCourseregistrationidAverageGradePathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1PersonResumeeCourseregistrationidAverageGradePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1PersonResumeeCourseregistrationidAverageGrade200Schema =
  z.number() as unknown as ToZod<PostApiV1PersonResumeeCourseregistrationidAverageGrade200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PersonResumeeCourseregistrationidAverageGrade400Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeCourseregistrationidAverageGrade400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PersonResumeeCourseregistrationidAverageGrade401Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeCourseregistrationidAverageGrade401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PersonResumeeCourseregistrationidAverageGrade500Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeCourseregistrationidAverageGrade500>;

export const postApiV1PersonResumeeCourseregistrationidAverageGradeMutationResponseSchema =
  z.lazy(
    () => postApiV1PersonResumeeCourseregistrationidAverageGrade200Schema,
  ) as unknown as ToZod<PostApiV1PersonResumeeCourseregistrationidAverageGradeMutationResponse>;
